"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadData = void 0;
const downloadData_1 = require("./internal/downloadData");
function downloadData(input) {
    return (0, downloadData_1.downloadData)(input);
}
exports.downloadData = downloadData;
